import URL from 'url';
import buildParams from '../buildParams';

export enum Sizes {
  raw = 'raw',
  xlarge = '2560x1241',
  large3 = '1920x881',
  large2 = '1860x1240',
  large = '1440x701',
  medium3 = '1050x700',
  medium2 = '768x952',
  medium = '768x512',
  default = '490x300',
  small3 = '450x300',
  small2 = '414x664',
  small = '375x595',
  xsmall = '320x240',
}

export interface Options {
  size?:
    | 'raw'
    | '320x240'
    | '375x595'
    | '414x664'
    | '490x300'
    | '450x300'
    | '768x512'
    | '768x952'
    | '1050x700'
    | '1440x701'
    | '1860x1240'
    | '1920x881'
    | '2560x1241';
  transformation?: 'crop' | 'fit';
  rotation?: '0' | '90';
}

const ownerTypeTransformation = {
  room: 'listing',
};

export default function transformImageUrlToBosch(
  url: string,
  options: Options = {},
) {
  if (!url.includes('/v2/images/room/')) {
    return url;
  }

  const parsed = URL.parse(url);

  const withoutExtension =
    parsed.pathname?.replace(/\.(png|jpg|webp)/g, '') ?? '/';
  const [, , , ownerType, ownerID, fileUUID] = withoutExtension.split('/');
  const size = options?.size ?? 'raw';

  parsed.pathname = `/images/${
    ownerTypeTransformation[ownerType] ?? ownerType
  }/${ownerID}/${size}/${fileUUID}`;
  parsed.search = buildParams({
    t: options.transformation,
    r: options.rotation,
  });

  return URL.format(parsed);
}
